import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Button } from "@learningblocks/shared-components";
import style from "./style.module.scss";

/**
 * NextSectionButton:
 *  - Button clicked to go from Notebook Section to Next
 */
export function NextSectionButton(props) {
  const className = `${style.btn} ${props.className}`;

  const onClick = (event) => {
    event.preventDefault();
    props.onClick();
  };

  return (
    <Button onClick={onClick} className={className} tabIndex={props.tabIndex}>
      <FormattedMessage id="Next section" defaultMessage="Next section" />
    </Button>
  );
}

NextSectionButton.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * Callback for Button click
   */
  onClick: PropTypes.func,
  /**
   * tabIndex to set on button
   */
  tabIndex: PropTypes.number,
};

NextSectionButton.defaultProps = {
  className: "",
};
